import type { RouteRecordRaw } from 'vue-router'

export const adminAccountsRoutes: RouteRecordRaw[] = [
  {
    path: '/admin/accounts',
    name: 'admin-accounts',
    component: () => import('./pages/AdminAccountsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/accounts/:id',
    name: 'admin-account-detail',
    component: () => import('./pages/AdminAccountDetailsPage.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
]
